import React from 'react';

interface HeaderProps {
  onMenuButtonClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuButtonClick }) => {
  return (
    <header className="md:hidden bg-blue-600 text-white p-4 flex items-center justify-between shadow-lg sticky top-0 z-30">
      <h1 className="text-xl font-bold">SI</h1>
      <button 
        onClick={onMenuButtonClick} 
        className="p-2 rounded-md hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
        aria-label="Abrir menu"
      >
        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
    </header>
  );
};

export default Header;
